// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"b9130aaf","1142":"9436d7fc","1229":"fb711903","2145":"4fb91c76","6758":"0a4200d3","6795":"670b1747","8863":"43ac670a","8958":"01070f50","9176":"670b1747"}[chunkId] + ".chunk.css";
};